module.exports = __webpack_public_path__ + "3821ceaa70accbd28880f180220bdcb1.MP3";